export default "__VITE_ASSET__f$uVeolP__"